import { selectRouterQueryParameters } from '@noths/polaris-client-next-redux';
import getConfig from 'next/config';

import { Loop54SearchAlgorithm } from 'src/constants/featureFlags';
import { NextConfig } from 'src/types';
import { ReduxApplicationState } from '../combinedReducer';

const { publicRuntimeConfig } = getConfig() as NextConfig;

const loop54Endpoints = {
  plp: publicRuntimeConfig.endpoints.loop54Categories,
  search: publicRuntimeConfig.endpoints.loop54Search,
  searchVariant: publicRuntimeConfig.endpoints.loop54SearchVariant,
};

export const selectLoop54EndpointFromReferrer = (
  state: ReduxApplicationState,
): string | undefined => {
  const { referredBy } = selectRouterQueryParameters(state);
  const referrer = (Array.isArray(referredBy) ? referredBy[0] : referredBy) ?? '';

  const isSearchFeatureVariant =
    (state.userConfiguration?.featureFlags || {})[Loop54SearchAlgorithm.NAME] ===
    Loop54SearchAlgorithm.VARIANT;

  if (referrer === 'search' && isSearchFeatureVariant) {
    return loop54Endpoints.searchVariant;
  }

  return loop54Endpoints[referrer];
};
